import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { mq } from 'src/themes';
import { feedPageRoute, libraryPageRoute, searchResultsPageRoute } from 'src/routes/route-list';
import { Box } from 'src/components/atoms';
import { Chips } from './Chips';
import { SearchBar } from './SearchBar';
import { LayoutUser } from './user/LayoutUser';

interface Props {
  hideChips?: boolean;
  hideLayoutUser?: boolean;
}
interface Props {
  hideChips?: boolean;
  hideLayoutUser?: boolean;
}

const StyledMainContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.75rem;
  margin-bottom: 1rem;

  ${mq.sm} {
    width: 100%;
  }
`;

const StyledSearchBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 13.5rem);

  ${mq.md} {
    width: 100%;
  }
`;

export const MainContentHeader = ({ hideChips, hideLayoutUser }: Props) => {
  const location = useLocation();

  const pagesWhereHeaderIsDisplayed = [feedPageRoute, libraryPageRoute, searchResultsPageRoute];
  const shouldDisplayHeader = pagesWhereHeaderIsDisplayed.includes(location.pathname);

  if (!shouldDisplayHeader) {
    return (
      <StyledMainContentHeader>
        <StyledSearchBarContainer />
        {!hideLayoutUser && (
          <Box width='13.5rem'>
            <LayoutUser />
          </Box>
        )}
      </StyledMainContentHeader>
    );
  }

  return (
    <StyledMainContentHeader>
      <StyledSearchBarContainer>
        <SearchBar />
        {!hideChips && <Chips />}
      </StyledSearchBarContainer>

      {!hideLayoutUser && (
        <Box width='13.5rem'>
          <LayoutUser />
        </Box>
      )}
    </StyledMainContentHeader>
  );
};
